import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Pagination } from '../Pagination'

export const GridItems = (props) => {
    const items = props.items;


    return (
        <>
            <div className="row">
                {!!items && items.map((item) => (
                    < div className="col-lg-6 col-md-12" >
                        <Link to={`/item`}  className="listing-item-container">
                            <div className="listing-item">
                                <img src={item.defaultImagePath} alt="" />
                                {item.showNowOpen && (
                                    <div className="listing-badge now-open">Now Open</div>
                                )}
                                {item.showNowClosed && (
                                    <div className="listing-badge now-closed">Now Closed</div>
                                )}
                                <div className="listing-item-content">
                                    <span className="tag">{item.tag}</span>
                                    <h3>{item.title} {item.verified && (
                                        <i className="verified-icon"></i>
                                    )}</h3>
                                    <span>{item.address}</span>
                                </div>
                                {item.isFavorite ? (
                                    <span className="like-icon liked"></span>
                                ) : (
                                    <span className="like-icon"></span>
                                )}
                            </div>
                            <div className="star-rating" data-rating={item.rating}>
                                <div className="rating-counter">({item.reviews} reviews)</div>
                            </div>
                        </Link>
                    </div>
                ))}
            </div >
            <Pagination />
        </>
    )
}